export default __webpack_public_path__ + "static/media/ic-cross.f0a55f6d.svg";